var _path, _path2, _stop, _stop2, _stop3, _stop4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToastErrorV2 = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#" + _uid + "toast-error-v2_svg__a)",
    d: "M12 .25C18.49.25 23.75 5.51 23.75 12S18.49 23.75 12 23.75.25 18.49.25 12 5.51.25 12 .25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#" + _uid + "toast-error-v2_svg__b)",
    strokeWidth: 0.5,
    d: "M12 .25C18.49.25 23.75 5.51 23.75 12S18.49 23.75 12 23.75.25 18.49.25 12 5.51.25 12 .25Z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.25 8.25h1.5v7.5h-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E02424",
    d: "m17.73 9.244-2.974-2.973A.93.93 0 0 0 14.103 6H9.897a.93.93 0 0 0-.653.27L6.271 9.245A.93.93 0 0 0 6 9.897v4.206c0 .245.098.48.27.653l2.974 2.973a.93.93 0 0 0 .653.271h4.206a.93.93 0 0 0 .653-.27l2.973-2.974a.93.93 0 0 0 .271-.653V9.897a.93.93 0 0 0-.27-.653m-6.191-.013a.462.462 0 1 1 .922 0v3.23a.462.462 0 0 1-.922 0zm.461 6a.692.692 0 1 1 0-1.384.692.692 0 0 1 0 1.384"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "toast-error-v2_svg__a",
    x1: -0.951,
    x2: 12,
    y1: -24.333,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E02424"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3C"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "toast-error-v2_svg__b",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F69"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4E4E"
  })))));
};
export { SvgToastErrorV2 as ReactComponent };
export default __webpack_public_path__ + "147de984d5eb673a6246f1326ffb65c9.svg";